import { ReactNode } from 'react';
import { LOGIN_ROUTES, TOKENS } from 'pages/auth/constants';
import { useLocalStorage } from 'hooks';
import { isRenderedAsIframeInNewUI, isNewBackend } from 'config';

type AuthGuardProps = {
  children: ReactNode;
};

export default function AuthGuard({ children }: AuthGuardProps) {
  const key = isNewBackend ? TOKENS.ACCESS_TOKEN_EXPIRATION : TOKENS.AUTH_TOKEN_SESSION_KEY;
  const [token] = useLocalStorage(key, null);

  if (!token && !isRenderedAsIframeInNewUI) {
    // remove all intervals and timeouts
    window.location.href = window.location.origin + LOGIN_ROUTES.LOGIN;
    return null;
  }

  if (!token && isRenderedAsIframeInNewUI) {
    return <></>;
  }

  return <>{children}</>;
}
